// @flow weak

import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import bemify, { toModifiers } from 'bemify-js';

import OutsideClickable from 'web-ssr/app/common/components/OutsideClickable';
import Menu, { MenuSectionShape } from 'web-ssr/app/common/components/Menu';
import { getRef, setRef } from 'web-ssr/app/common/utils/ReactUtils';
import 'web-ssr/app/common/components/DropdownMenu/DropdownMenu.scss';

const block = 'dropdown-menu-v2';
const bem = bemify(block);

export const DropdownMenuWrapper = props => (
  <div
    className={bemify(`${block}-wrapper`)(
      toModifiers(props.kind),
      props.className
    )}
  >
    {props.children}
  </div>
);

const DropdownMenu = createReactClass({
  displayName: 'DropdownMenu',
  size: (null: ?{ height: number, width: number }),
  mixins: [PureRenderMixin],

  propTypes: {
    children: MenuSectionShape.children,
    items: MenuSectionShape.items,
    kind: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
      PropTypes.string,
    ]).isRequired,
    Menu: PropTypes.func.isRequired,
    shouldRetainSize: PropTypes.bool,
    className: PropTypes.string,
    style: PropTypes.object,
    onClickOutside: PropTypes.func,
  },

  getDefaultProps() {
    return {
      kind: 'below justify-right',
      Menu,
      shouldRetainSize: false,
    };
  },

  computeInitialSize() {
    const menu = getRef(this, 'menu');

    // Using `offset*` instead of `getBoundingClientRect`
    // because the latter returns non-integers.
    // Also storing on `this` instead of `state` because
    // this is intended to be constant throughout the
    // life of the component and we don't want `state`
    // in this component anyway.
    this.size = {
      height: menu.offsetHeight,
      width: menu.offsetWidth,
    };
  },

  componentDidMount() {
    if (this.props.shouldRetainSize) {
      this.computeInitialSize();
    }
  },

  render() {
    const { props } = this;
    const className = bem(toModifiers(props.kind), props.className);
    const style = {
      ...(props.style || {}),
      ...(this.size || {}),
    };
    const menuProps = _.omit(props, [
      'className',
      'kind',
      'Menu',
      'shouldRetainSize',
      'onClickOutside',
    ]);
    const MenuComponent = props.Menu;
    const menu = (
      <div className={className} ref={setRef(this, 'menu')} style={style}>
        <MenuComponent className={bem('__menu')} {...menuProps} />
      </div>
    );
    return !props.onClickOutside ? (
      menu
    ) : (
      <OutsideClickable onClickOutside={props.onClickOutside}>
        {menu}
      </OutsideClickable>
    );
  },
});

export default DropdownMenu;
